import type { StagedActionView } from '@renderer/overlay/Sidepanel/hooks/use-staged-actions'
import { ActionTagBadge } from './badge'

interface ActionTagBadgeCollectionProps {
  keyName: string
  tags: Array<StagedActionView['tags'][number]>
  editable?: boolean
  singleLine?: boolean
}

export function ActionTagBadgeCollection({
  keyName,
  tags,
  editable = false,
  singleLine = false,
}: ActionTagBadgeCollectionProps) {
  return (
    <>
      {tags.map((tag) => (
        <ActionTagBadge
          key={`${keyName}-${tag.value}`}
          tags={[tag]}
          keyName={tag.key}
          editable={editable}
          singleLine={singleLine}
        />
      ))}

      {tags.length === 0 && <ActionTagBadge tags={[]} keyName={keyName} editable={editable} />}
    </>
  )
}
